<template>
<div class="body-main">
  <div class="header">
<!--    <el-button size="mini" @click="editor()">添加</el-button>-->

    <el-input v-model="where2.keyword" style="width: 200px;margin-left: 10px;" size="mini" placeholder="请输入名称" clearable></el-input>

    <el-select v-model="where2.status" class="m-2" filterable placeholder="选择状态" clearable style="margin-left: 10px;" size="mini">
      <el-option
        v-for="item in [{name:'终止合作',value:0},{name:'合作中',value:1}]"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
  <div class="table-wrap">
    <el-table
      v-loading="loading" :data="pageData.data"
      border
      @sort-change="onSorTable"
      style="width: 100%" height="60vh">
      <el-table-column
        prop="project_name"
        label="项目"
        width="200" align="center" sortable="custom" fixed></el-table-column>
      <el-table-column
        prop="company_name"
        label="第三方单位名称" width="240" align="center" sortable="custom" fixed></el-table-column>
      <el-table-column label="移交情况" align="center">
        <el-table-column align="center" sortable="custom"
                         prop="house_count"
                         label="移交户数"
                         width="150" :formatter="intMilFormatter">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
                         prop="house_money"
                         label="催缴费用"
                         width="150" :formatter="milFormatter">
        </el-table-column>
      </el-table-column>
      <el-table-column label="当月" align="center">
        <el-table-column align="center" sortable="custom"
          prop="collection_num"
          label="催缴次数"
          width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="collection_house_num"
          label="催缴户数"
          width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="collection_house_rate"
          label="催缴率"
          width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="payment_collection_num"
          label="回款户数"
          width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="payment_collection_amount"
          label="回款金额"
          width="150" :formatter="milFormatter">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="payment_collection_rate"
          label="回款率"
          width="150">
        </el-table-column>
      </el-table-column>
      <el-table-column label="累计" align="center">
        <el-table-column align="center" sortable="custom"
          prop="cumulative_collection_num"
          label="催缴次数"
          width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="cumulative_collection_house_num"
          label="催缴户数"
          width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="cumulative_collection_house_rate"
          label="催缴率"
          width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="cumulative_payment_collection_num"
          label="回款户数"
          width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="cumulative_payment_collection_amount"
          label="回款金额"
          width="150" :formatter="milFormatter">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
          prop="cumulative_payment_collection_rate"
          label="回款率"
          width="150">
        </el-table-column>
      </el-table-column>
      <el-table-column label="服务费" align="center">
        <el-table-column align="center" sortable="custom"
                         prop="final_calculation_money"
                         label="总费用"
                         width="150" :formatter="milFormatter">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
                         prop="settlement_money"
                         label="已结算"
                         width="150" :formatter="milFormatter">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
                         prop="unsettled_money"
                         label="未结算"
                         width="150" :formatter="milFormatter">
        </el-table-column>
      </el-table-column>
      <el-table-column label="合同信息" align="center">
        <el-table-column align="center"
                         prop="contact_name"
                         label="对接人"
                         width="150">
        </el-table-column>
        <el-table-column align="center"
                         prop="contact_telephone"
                         label="对接人电话"
                         width="150">
        </el-table-column>
<!--        <el-table-column align="center"-->
<!--                         prop="contact_telephone"-->
<!--                         label="合同附件"-->
<!--                         width="150">-->
<!--        </el-table-column>-->
        <el-table-column align="center"
                         prop="bank_card"
                         label="收款账户"
                         width="200">
        </el-table-column>
        <el-table-column align="center"
                         prop="bank_name"
                         label="开户行"
                         width="200">
        </el-table-column>
        <el-table-column align="center"
                         prop="online_service_rate"
                         label="在管-服务费率(%)"
                         width="150"></el-table-column>
        <el-table-column align="center"
                         prop="online_ss_service_rate"
                         label="在管-诉讼费率(%)"
                         width="150"></el-table-column>
        <el-table-column align="center"
                         prop="offline_service_rate"
                         label="撤场-服务费率(%)"
                         width="150"></el-table-column>
        <el-table-column align="center"
                         prop="offline_ss_service_rate"
                         label="撤场-诉讼费率(%)"
                         width="150"></el-table-column>
        <el-table-column align="center"
                         prop="start_time"
                         label="开始时间" sortable="custom" width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
                         prop="end_time"
                         label="结束时间"
                         width="150">
        </el-table-column>
        <el-table-column align="center" sortable="custom"
                         prop="execution_date"
                         label="合作签订时间"
                         width="150">
        </el-table-column>
        <el-table-column align="center"
                         prop="company_day"
                         label="合同时长（天）"
                         width="150">
        </el-table-column>
      </el-table-column>

      <el-table-column align="center"
        prop="status"
        label="状态"
        width="100">
        <template slot-scope="scope">
          {{scope.row.status?'合作中':'终止合作'}}
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="created_at"-->
<!--        label="创建时间"-->
<!--        width="100">-->
<!--      </el-table-column>-->
      <el-table-column align="center" sortable="custom"
        prop="updated_at"
        label="更新时间"
        width="100">
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination
      @current-change="pageChange"
      :current-page="pageData.current_page"
      :page-size="pageData.per_page"
      layout="total, prev, pager, next"
      :total="pageData.total">
    </el-pagination>
  </div>
</div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "ThirdPartyCompanyProject",
  inject:['where','reginWhere'],
  props:{
    urge_type:{
      type:Number,
      default:3
    }
  },
  data(){
    return{
      where2:{
        keyword:"",
        status:"",
        order_by:"",
      },
      pageData: {
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
      loading: false,
      formData:{
        name:"",
        head_name:"",
        telephone:"",
        status:1,
        remark:""
      },
      dialogVisible:false,
    }
  },
  mounted() {
    this.pageChange(1)
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where2)
      where = {
        ...where,
        ...ERP.reJson(that.where),
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        urge_type:that.urge_type,
        // area_id:that.areaId
      }

      ButlerHttp.post("ThirdPartyCommon/getProjectCompanyList?page="+that.pageData.current_page+"&per_page="+that.pageData.per_page, {
        ...where
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.current_page = i
      this.getList()
    },
    onSorTable({column, prop, order}){
      console.log({column, prop, order})
      const that=this;
      if(order){
        let orderProp={
          "project_name":"cp.project_name",
          "company_name":"c.name",
          "start_time":"cpc.start_time",
          "end_time":"cpc.end_time",
          "house_count":"cp.house_count",
          "house_money":"cp.house_money",
          "collection_num":"cps.collection_num",
          "collection_house_num":"cps.collection_house_num",
          "collection_house_rate":"cps.collection_house_rate",
          "payment_collection_num":"cps.payment_collection_num",
          "payment_collection_amount":"cps.payment_collection_amount",
          "payment_collection_rate":"cps.payment_collection_rate",
          "cumulative_collection_num":"cps.cumulative_collection_num",
          "cumulative_collection_house_num":"cps.cumulative_collection_house_num",
          "cumulative_collection_house_rate":"cps.cumulative_collection_house_rate",
          "cumulative_payment_collection_num":"cps.cumulative_payment_collection_num",
          "cumulative_payment_collection_amount":"cps.cumulative_payment_collection_amount",
          "cumulative_payment_collection_rate":"cps.cumulative_payment_collection_rate",
          "final_calculation_money":"cps.final_calculation_money",
          "settlement_money":"cps.settlement_money",
          "unsettled_money":"cps.unsettled_money",
          "execution_date":"cpc.execution_date",
          "updated_at":"cp.updated_at",
        }
        let sortOrder = order === 'ascending' ? 'asc' : 'desc'; // 转换为后端期望的格式（例如 'asc'/'desc'）
        let field=orderProp[prop]||null
        if(field) {
          that.where2.order_by=`${field} ${sortOrder}`
        }else {
          that.where2.order_by=''
        }
      }else {
        that.where2.order_by=''
      }
      that.pageChange(1);

    },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
    },
    "where2.keyword":function (n,o) {
      this.pageChange(1)
    },
    "where2.status":function (n,o) {
      this.pageChange(1)
    },
    "where.thrid_company_id":function (n,o) {
      this.pageChange(1)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.body-main{
  .header{
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
  }
  .table-wrap{
    >>>.el-table--border, .el-table--group{
      border: 1px solid #000000;
    }
    >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
      border-bottom: 1px solid #000000;
    }
    >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
      border-right: 1px solid #000000;
    }
    >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
      border-bottom: 1px solid #000000;
    }
    >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
      border-bottom: 1px solid #000000;
    }
  }
  .pagination-wrap{
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyCompanyProject.vue